export const ORGANIZATION_TYPE = {
  HYBRID: "hybrid",
  OTT: "ott",
  FAST: "fast",
} as const;

type OrganizationTypeKeys = keyof typeof ORGANIZATION_TYPE;

export type OrganizationType = (typeof ORGANIZATION_TYPE)[OrganizationTypeKeys];
